// extracted by mini-css-extract-plugin
module.exports = {"text":"subscription-form_text__LHSp2","emailInput":"subscription-form_emailInput__yyT_j","button":"subscription-form_button__mQZXZ","picture":"subscription-form_picture__USu8b"};